import Vue from 'vue'
import Router from 'vue-router'

// Containers
import * as Container from '@/f1/containers'
import * as Views from '@/f1/views'
import * as WMDS from '@/f1/views/WMDS'
import * as WSFinder from '@/f1/views/WSFinder'
import * as WebCastle from '@/f1/views/WebCastle'
// import * as Integrity from '@/f1/views/integrity'
// import config from '@/f1/config'

import WMDS_Dashboard from '@/f1/views/dashboard/WMDS_Dashboard.i18n'
import WSFinder_Dashboard from '@/f1/views/dashboard/WSFinder_Dashboard.i18n'
import WebCastle_Dashboard from '@/f1/views/dashboard/WebCastle_Dashboard.i18n'
import WFDetect_Dashboard from '@/f1/views/dashboard/WFDetect_Dashboard.i18n'

Vue.use(Router)

// const componentManual = { template: `<script>window.location.href = "https://${location.host.replace(/^[^\.]*\./, 'api.')}/downloads/v1/${config.manual}"</script>`}
// const componentManual = { template: `<script>window.open("https://${location.host.replace(/^[^\.]*\./, 'api.')}/downloads/v1/${config.manual}")</script>`}

export default new Router({
  mode: 'hash', // hash or
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/login', name: 'auth_login', component: Views.Login },
    { path: '/reset', name: 'auth_reset', component: Views.Reset, props: (route) => ({ token : route.query.token, username : route.query.username }) },
    { path: '/logout', name: 'auth_logout', component: Views.Logout },
    // { path: '/manual', component: componentManual },
    {
      path: '/', redirect: '/welcome', name: 'main', meta: { label: 'Main', requiresAuth: true }, component: Container.Private,
      children: [
        { path: 'downloads', name: 'downloads', meta: { label: 'Downloads' }, component: Views.Downloads },
        { path: 'billing', name: 'billing', meta: { label: 'Billing System' }, component: Views.Billing },
        { path: 'welcome', name: 'welcome', meta: { label: 'Welcome' }, component: Views.Welcome },
        { path: 'report', name: 'report', meta: { label: 'Report' }, component: Views.Report },
        { path: 'profile/:tag?', name: 'profile', meta: { label: 'Profile' }, component: Views.Profile },
        { path: 'logs', name: 'log', meta: { label: 'Log' }, component: { render(c) { return c('router-view'); } }, children: [
          { path: 'login/:id?', name: 'login_log', meta: { label: 'Login' }, component: Views.Logs.Login },
          { path: 'action/:id?', name: 'action_log', meta: { label: 'Action' }, component: Views.Logs.Action },
          { path: 'system/:id?', name: 'system_log', meta: { label: 'System' }, component: Views.Logs.System },
          { path: 'mail/:id?', name: 'mail_log', meta: { label: 'Mail' }, component: Views.Logs.Mail },
        ]},
        { path: 'boards', name: 'board', meta: { label: 'Board' }, component: { render(c) { return c('router-view'); } }, children: [
          { path: 'notice/:id?', name: 'notice', meta: { label: 'Notice' }, component: Views.Notice.Base },
          { path: 'faq/:id?/:tag?', name: 'faq', meta: { label: 'FAQ' }, component: Views.FAQ.Base },
          { path: 'qna/:id?/:tag?', name: 'qna', meta: { label: 'Q & A' }, component: Views.QNA.Base },
        ]},
        { path: 'group/:tag?', name: 'group', meta:{ label: 'Group'}, component: Views.Group },
        { path: 'user/:id?/:tag?', name: 'user', meta:{ label: 'User'}, component: Views.User.Base }
      ]
    },
    {
      path: '/integrity', redirect: '/integrity/dashboard', name: 'WFDetector', component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'dashboard', name: 'integrity_dashboard', meta: { label: 'Main' }, component: WFDetect_Dashboard },
        { path: 'main', name: 'integrity_main', meta: { label: 'Main' }, component: Views.Integrity.Main },
        { path: 'wsfinder/:id?/:tag?', name: 'integrity_wsfinder', meta: { label: 'WSFinder' }, component: Views.Integrity.WSFinder },
        { path: 'wmds/:id?/:tag?', name: 'integrity_wmds', meta: { label: 'WMDS' }, component: Views.Integrity.WMDS },
        { path: 'detect/:id?/:tag?', name: 'integrity_detect', meta: { label: 'Detect' }, component: Views.Integrity.Result },
      ]
    },
    {
      path: '/webcastle', redirect: '/webcastle/dashboard', name : "WEBCastle", component: Container.Private, // name delete
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'dashboard', name: 'webcastle_dashboard', meta: { label: 'Dashboard' }, component: WebCastle_Dashboard },
        { path: 'modules/:version?/:id?/:tag?', name: 'webcastle_modules', meta: { label: 'Modules' }, component: WebCastle.Modules.Base },
        { path: 'log/:id?/:tag?', name: 'webcastle_log', meta: { label: 'Log' }, component: WebCastle.Log.Base },
        { path: 'report/:id?/:tag?', name: 'webcastle_report', meta: { label: 'Report' }, component: WebCastle.Report.Base },
        // { path: 'multiplexing/:id?/:tag?', name: 'webcastle_multiplexing', meta: { label: 'Multiplexing' }, component: WebCastle.Multiplexing.Base }
      ]
    },
    {
      path: '/wsfinder', redirect: '/wsfinder/dashboard', name : "WSFinder", component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'dashboard', name: 'wsfinder_dashboard', meta: { label: 'Dashboard' }, component: WSFinder_Dashboard },
        { path: 'agent/:id?/:tag?', name: 'wsfinder_agent', meta: { label: 'Agent' }, component: WSFinder.Agent.Base },
        { path: 'detect/:id?/:tag?', name: 'wsfinder_detect', meta: { label: 'Detect' }, component: WSFinder.Detect.Base },
        { path: 'result/:id?/:tag?', name: 'wsfinder_result', meta: { label: 'Result' }, component: WSFinder.Result.Base },
        { path: 'pattern/:id?/:tag?', name: 'wsfinder_pattern', meta: { label: 'Pattern' }, component: WSFinder.Pattern.Base },
        { path: 'hash/:id?/:tag?', name: 'wsfinder_hash', meta: { label: 'Exception' }, component: WSFinder.Hash.Base },
        { path: 'report/:id?/:tag?', name: 'wsfinder_report', meta: { label: 'Analysis request' }, component: WSFinder.Report.Base },
        { path: 'summary/:id?/:tag?', name: 'wsfinder_summary', meta: { label: 'Report' }, component: WSFinder.Summary.Base }
      ]
    },
    {
      path: '/wmds', redirect: '/wmds/dashboard', name : "WMDS",  component: Container.Private,
      meta: { requiresAuth: true }, // require auth. (main.js - router filter)
      children: [
        { path: 'dashboard', name: 'wmds_dashboard', meta: { label: 'Dashboard' }, component: WMDS_Dashboard },
        { path: 'site/:id?/:tag?', name: 'wmds_site', meta: { label: 'Site List' }, component: WMDS.Site.Base },
        { path: 'detect/:id?/:tag?', name: 'wmds_detect', meta: { label: 'Site Detect' }, component: WMDS.Detect.Base },
        { path: 'pattern/:id?/:tag?', name: 'wmds_pattern', meta: { label: 'Pattern' }, component: WMDS.Pattern.Base },

        { path: 'result/:site_id?/:result_id?', name: 'wmds_result', meta: { label: 'Site Result' }, component: WMDS.Result.Base },
        { path: 'policy/:id?/:tag?', name: 'wmds_policy', meta: { label: 'Policy' }, component: WMDS.Policy.Base },
        { path: 'schedule/:id?/:tag?', name: 'wmds_schedule', meta: { label: 'Schedule' }, component: WMDS.Schedule.Base }
      ]
    },
    { path: '*', redirect: '/' }
  ]
});

window['views'] = Views
